import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import s from "./user.module.css"
import { Grid } from '@mui/material';
import { notificationHandler } from '../../utils/Notification';
import { uploadTransactionVideoUrl_api, uploadVideoUrl_api } from '../api/user';
import { getBaseUrl } from "../../utils";
// import { uploadQuestionCsvFile } from '../api/question';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '4px solid  #b22029',
    boxShadow: 24,
    p: 4,
};

export default function UploadVideoUrl({ open, setOpen, userId,subscriptionTransactionId,type ,typeForPopUp}) {
    console.log(userId," this is the user id on the page of the pop up of uploading the url in the list ")
    // const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [media, setMedia] = React.useState(null)


    const uploadVideoUrl = async () => {
        if(typeForPopUp === "certificate"){
            let temp = new FormData();
            temp.append("transactionId", subscriptionTransactionId);
            temp.append("certificate", media);
            try {
                const res = await fetch(getBaseUrl() + "admin/add_Certificate", {
                    method: "POST",
                    body: temp,
                });
                const result = await res.json();
                if (result.status) {
                    notificationHandler({ type: "success", msg: result.message })
                    setOpen(false)
                } else {
                    notificationHandler({ type: "danger", msg: result.message })
                }
            } catch (error) {
                notificationHandler({ type: "danger", msg: error.message })
                console.log(error)
            }
        }else{
            let temp={
                transactionId:subscriptionTransactionId,
                userId:userId,
                videoUrl :media 
               }
                if(type==="transaction"){
                    try {
                        const res = await uploadTransactionVideoUrl_api(temp)
                        if (res.data.status) {
                            notificationHandler({ type: "success", msg: res.data.message })
                            setOpen(false)
                        } else {
                            notificationHandler({ type: "danger", msg: res.data.message })
                        }
                    } catch (error) {
                        notificationHandler({ type: "danger", msg: error.message })
                        console.log(error)
                    }
                }else{
                    try {
                        const res = await uploadVideoUrl_api(temp)
                        if (res.data.status) {
                            notificationHandler({ type: "success", msg: res.data.message })
                            setOpen(false)
                        } else {
                            notificationHandler({ type: "danger", msg: res.data.message })
                        }
                    } catch (error) {
                        notificationHandler({ type: "danger", msg: error.message })
                        console.log(error)
                    }
                }
        }
      
    }

    return (
        <div>
            {/* <Button onClick={handleOpen}>Open modal</Button> */}
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        {typeForPopUp === "certificate" ? "Upload Certificate" : "Upload Video Url"}
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        <Grid xs={12}>
                            <div className='form-group'>
                                {typeForPopUp === "certificate" ? 
                                <input className='form-control' type='file' accept="image/*" name='certificate' onChange={(e) => setMedia(e.target.files[0])} />
                                : <input className='form-control' type='text' placeholder='paste url' name='url' onChange={(e) => setMedia(e.target.value)} />}
                            </div>
                        </Grid>
                    </Typography>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        <div style={{ display: "flex", justifyContent: "end", marginTop: "1rem" }}>
                            <span className={s["title"]} onClick={uploadVideoUrl}>
                                UPLOAD
                            </span>
                        </div>
                    </Typography>
                </Box>
            </Modal>
        </div>
    );
}   